import { render, staticRenderFns } from "./quiz-question-answer-create.html?vue&type=template&id=4bdfddd6&scoped=true&"
import script from "./quiz-question-answer-create.js?vue&type=script&lang=js&"
export * from "./quiz-question-answer-create.js?vue&type=script&lang=js&"
import style0 from "./quiz-question-answer-create.scss?vue&type=style&index=0&id=4bdfddd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdfddd6",
  null
  
)

export default component.exports